export const ADMIN_ROUTE = '/admin'
export const SHOP_ROUTE = '/shop'
export const BASKET_ROUTE = '/basket'
export const PRODUCT_ROUTE = '/product'
export const ABOUT_ROUTE = '/about'
export const HISTORY_ROUTE = '/story'
export const PERSONAL_PAGE_ROUTE = '/personal_page'
export const ADDRESS_ROUTE = '/address'
export const ORDER_ROUTE = '/order'